import {Space} from "antd";
import {BundleSessionSessionPeriodNumberOfSessionFormField} from "./number-of-session";
import {BundleSessionSessionPeriodBookingIntervalFormField} from "./booking-interval";

export function BundleSessionSessionPeriodFormFields() {
  return (
    <Space size={16} direction="vertical" style={{display: "flex"}}>
      <BundleSessionSessionPeriodNumberOfSessionFormField />
      <BundleSessionSessionPeriodBookingIntervalFormField />
    </Space>
  );
}
